import React, { useState } from 'react';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { Checkbox } from 'ui';
import styles from './duplicate-hierarchy-modal.scss';

interface DuplicateHierarchyModalProps {
  codeId: number;
  codeDescription: string;
  fetching: number;
  translation: any;
  onClose: () => void;
  onDone: (withDescendants: boolean) => void;
}

export const DuplicateHierarchyModal: React.FC<DuplicateHierarchyModalProps> =
  ({ codeId, codeDescription, fetching, translation, onClose, onDone }) => {

    const [includeDescendants, setIncludeDescendants] = useState(false);
    const checkboxOnChange = (value: number) => setIncludeDescendants(!!value);
    const handleDone = () => onDone(includeDescendants);

    return <ModalWrapper
      headerTitle={translation.duplicate_hierarchy_title}
      btnTitle={translation.duplicate_hierarchy_save_with}
      btnActionTitle={translation.duplicate_hierarchy_save_without}
      onClose={onClose}
      btnCancelTitle={translation.cancel}
      onDone={handleDone}
      closeOnDone={false}
      isDisabled={!!fetching}>
      <div className="row">
        <div className="col-12">
          <p className={styles.multilineText}>
            {replaceTemplateString(
              translation.duplicate_hierarchy_info,
              codeId,
              codeDescription)}
          </p>
          <Checkbox
            className={undefined}
            componentId={'include-descendants-checkbox'}
            onChange={checkboxOnChange}
            info={{
              text: translation.duplicate_hierarchy_hint,
              visible: true
            }}
            label={{ visible: true, text: translation.duplicate_hierarchy_option }}
            value={includeDescendants ? 1 : 0} />
        </div>
      </div>
    </ModalWrapper>;
  };
